import axios from 'axios';
import { getSelectedFarmId, getSelectedYear, getSelectedPlot, getSelectedLang } from './common';

export async function getContent(getToken, content, data) {
    
      try {
        const token = await getToken;
        const response = await axios.get(content, {
            params: { farmId: getSelectedFarmId(), farmYear: getSelectedYear(), ...data },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    }
    catch (e) {
        console.log(e);
        return [];
    }
}

export async function getContentWithAction(getToken, content, action, data) {

    try {
        const token = await getToken;
        const response = await axios.get(content + '/' + action, {
            params: { farmId: getSelectedFarmId(), farmYear: getSelectedYear(), lang: getSelectedLang(), ...data },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return response.data;
    }
    catch (e) {
        return new Promise((resolve, reject) => {
            console.log(e);
            reject();
        });
    }
}

export async function getContentWithActionNoParams(getToken, content, action) {

    try {
        const token = await getToken;
        const response = await axios.get(content + '/' + action, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return response.data;
    }
    catch (e) {
        console.log(e);
    }
}

export async function getContentWithActionAndLanguage(getToken, content, action, data) {

    try {
        const token = await getToken;
        const response = await axios.get(content + '/' + action, {
            params: { lang: getSelectedLang() },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return response.data;
    }
    catch (e) {
        console.log(e);
    }
}

export async function getContentWithActionAndFarmId(getToken, content, action, data) {

    try {
        const token = await getToken;
        const response = await axios.get(content + '/' + action, {
            params: { farmId: getSelectedFarmId() },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return response.data;
    }
    catch (e) {
        console.log(e);
    }
}

export async function getContentWithActionAndPlantId(getToken, content, action, data) {

    try {
        const token = await getToken;
        const response = await axios.get(content + '/' + action, {
            params: { plantId: getSelectedPlot().plantId, lang: getSelectedLang() },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return response.data;
    }
    catch (e) {
        console.log(e);
    }
}

export async function postContentWithAction(getToken, content, action, data, callback = () => { }) {

    try {
        const token = await getToken;
        const response = await axios.post(content + '/' + action, { farmId: Number(getSelectedFarmId()), farmYear: getSelectedYear(), ...data }, {
            headers: {               
                'Authorization': `Bearer ${token}`
            }
        });

        callback(response.data);
    }
    catch (e) {
        return new Promise((resolve, reject) => {
            console.log(e);
            reject(e);
        });
    }
}

/// CORRECT way to handle async with returning data
export async function postContentWithAction_(getToken, content, action, data = () => { }) {

    try {
        const token = await getToken;
        const response = await axios.post(content + '/' + action, { farmId: Number(getSelectedFarmId()), farmYear: getSelectedYear(), lang: getSelectedLang(), ...data }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return response.data;
    }
    catch (e) {
        return new Promise((resolve, reject) => {
            console.log(e);
            reject(e);
        });
    }
}


export async function putContentWithAction(getToken, content, action, data) {

    try {
        const token = await getToken;
        const response = await axios.put(content + '/' + action, { farmId: Number(getSelectedFarmId()), farmYear: getSelectedYear(), ...data }, {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });

        return response.data;
    }
    catch (e) {
        return new Promise((resolve, reject) => {
            console.log(e);
            reject(e);
        });
    }
}

export async function putContentWithActionFertility(getToken, content, action, data, callback = () => { }) {

    try {
        const token = await getToken;
        const response = await axios.put(content + '/' + action, { farmId: Number(getSelectedFarmId()), farmYear: getSelectedYear(), ...data }, {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });

        callback(response.data);
    }
    catch (e) {
        return new Promise((resolve, reject) => {
            console.log(e);
            reject();
        });
    }
}